import React from 'react';
import { sortBy, prop } from 'ramda';
import { useGetAllActionTypesSuspense, useGetAllElementTypesSuspense, useGetAllHazardsSuspense, } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import EditFindingForm from './EditFindingForm';
const EditFindingFormWrapper = ({ onClose, canEdit }) => {
    const { data: hazardsResponse } = useGetAllHazardsSuspense({
        query: { staleTime: Infinity },
    });
    const { data: elementsResponse } = useGetAllElementTypesSuspense({
        query: { staleTime: Infinity },
    });
    const { data: actionTypesResponse } = useGetAllActionTypesSuspense({
        query: { staleTime: Infinity },
    });
    const availableHazards = unwrapModel(hazardsResponse);
    const availableElements = unwrapModel(elementsResponse);
    const availableActionTypes = unwrapModel(actionTypesResponse);
    if (!availableHazards || !availableElements || !availableActionTypes)
        return null;
    const sortedElements = sortBy(prop('name'), availableElements);
    return (React.createElement(EditFindingForm, { canEdit: canEdit, onClose: onClose, availableElements: sortedElements, availableHazards: availableHazards, availableActionTypes: availableActionTypes }));
};
export default EditFindingFormWrapper;
